import { ReactNode } from 'react';

import { ChakraProvider, SystemContext } from '@chakra-ui/react';

import { CacheProvider } from '@emotion/react';

import { raspberrySsrTheme } from '@nocowanie/common-ui/theme/raspberry-theme';

import { useEmotionCache } from '@app/hooks/useEmotionCache';

export const ThemeProviderWithCache = ({
    theme,
    children,
}: {
    theme?: SystemContext;
    children: ReactNode;
}): ReactNode => {
    const { cache } = useEmotionCache();

    return (
        <CacheProvider value={cache}>
            <ChakraProvider value={theme ?? raspberrySsrTheme}>{children}</ChakraProvider>
        </CacheProvider>
    );
};
